// extracted by mini-css-extract-plugin
export default {"dashboardHeader":"Dashboard_dashboardHeader__NkZvE"};